var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet } from 'react-native';
import { FalsyFC, FalsyText, TouchableWeb } from "../../devsupport";
import { Interaction, styled } from "../../theme";
export
/**
 * A single tab within the BottomNavigation.
 * Bottom tabs should be rendered within BottomNavigation to provide a usable navigation component.
 *
 * @extends React.Component
 *
 * @property {ReactText | (TextProps) => ReactElement} title - String, number or a function component
 * to render within the tab.
 * If it is a function, expected to return a Text.
 *
 * @property {(ImageProps) => ReactElement} icon - Function component
 * to render within the tab.
 * Expected to return an Image.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example BottomNavigationTabSimpleUsage
 */
let BottomNavigationTab = (_dec = styled('BottomNavigationTab'), _dec(_class = (_temp = class BottomNavigationTab extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onMouseEnter", event => {
      this.props.eva.dispatch([Interaction.HOVER]);
      this.props.onMouseEnter && this.props.onMouseEnter(event);
    });

    _defineProperty(this, "onMouseLeave", event => {
      this.props.eva.dispatch([]);
      this.props.onMouseLeave && this.props.onMouseLeave(event);
    });

    _defineProperty(this, "onPress", () => {
      this.props.onSelect && this.props.onSelect(!this.props.selected);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        iconWidth,
        iconHeight,
        iconMarginVertical,
        iconTintColor,
        textMarginVertical,
        textFontFamily,
        textFontSize,
        textFontWeight,
        textColor
      } = source,
            containerParameters = _objectWithoutProperties(source, ["iconWidth", "iconHeight", "iconMarginVertical", "iconTintColor", "textMarginVertical", "textFontFamily", "textFontSize", "textFontWeight", "textColor"]);

      return {
        container: containerParameters,
        text: {
          marginVertical: textMarginVertical,
          fontFamily: textFontFamily,
          fontSize: textFontSize,
          fontWeight: textFontWeight,
          color: textColor
        },
        icon: {
          width: iconWidth,
          height: iconHeight,
          marginVertical: iconMarginVertical,
          tintColor: iconTintColor
        }
      };
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      title,
      icon
    } = _this$props,
          touchableProps = _objectWithoutProperties(_this$props, ["eva", "style", "title", "icon"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(TouchableWeb, _extends({}, touchableProps, {
      style: [evaStyle.container, styles.container, style],
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onPress: this.onPress
    }), /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.icon,
      component: icon
    }), /*#__PURE__*/React.createElement(FalsyText, {
      style: evaStyle.text,
      component: title
    }));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center'
  }
});